import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Table } from "reactstrap";
import { Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import { tableHeader } from "../../../constants/staffaccounts";
import actions, { useActions } from "../../../redux/actions";
import Portal from "./portal";
import themeColor from "../../../styles/themeColor";

const ActionDropdown = (props) => {
  const userActions = useActions(actions.UserActions);
  const { t } = useTranslation();
  const { setShowModal, setAlert, staff, isUpdateAllowed } = props;

  return (
    <div>
      <Dropdown>
        <Dropdown.Toggle className="btn btn-sm">{t("option")}</Dropdown.Toggle>
        {isUpdateAllowed ? (
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                userActions.select(staff);
                setShowModal(true);
              }}
            >
              {t("edit")}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                userActions.select(staff);
                setAlert({
                  ...alert,
                  content: t("removeRecord"),
                  show: true,
                  type: "default",
                });
              }}
            >
              {t("remove")}
            </Dropdown.Item>
          </Dropdown.Menu>
        ) : (
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                userActions.select(staff);
                setShowModal(true);
              }}
            >
              {t("view")}
            </Dropdown.Item>
          </Dropdown.Menu>
        )}
      </Dropdown>
    </div>
  );
};

const StaffList = (props) => {
  const { t } = useTranslation();
  const { staffAccounts } = props;
  const [staffAccountList, setStaffAccountList] = useState(staffAccounts);
  const user = useSelector((state) => state.user);
  const account = useSelector((state) => state.account);
  const userActions = useActions(actions.UserActions);
  const [showModal, setShowModal] = useState(false);
  const [alert, setAlert] = useState({
    show: false,
    title: "",
    type: "default",
    content: "",
  });
  const [isCreateAllowed, setIsCreateAllowed] = useState(false);
  const [isUpdateAllowed, setIsUpdateAllowed] = useState(false);

  const handleCloseAlert = () => {
    setAlert({ ...alert, show: false });
    window.location.reload();
  };

  const handleShowModal = () => {
    setShowModal(!showModal);
  };

  const handleRemove = () => {
    userActions.remove(
      user.selected._id,
      account.token,
      () => {
        setAlert({
          ...alert,
          show: true,
          title: t("success"),
          content: "",
          type: "success",
        });
      },
      () => {
        setAlert({
          ...alert,
          show: true,
          title: t("error"),
          content: "",
          type: "error",
        });
      }
    );
  };

  useEffect(() => {
    setStaffAccountList(staffAccounts);
  }, [staffAccounts]);

  useEffect(() => {
    if (
      account.permission.general.includes("user-create") ||
      account.permission.general.includes("*")
    )
      setIsCreateAllowed(true);
    if (
      account.permission.general.includes("user-update") ||
      account.permission.general.includes("*")
    )
      setIsUpdateAllowed(true);
  }, []);

  return (
    <div style={{ overflow: "auto" }}>
      {isCreateAllowed && (
        <button
          type="button"
          className="btn btn-primary"
          style={{ marginBottom: 20 }}
          onClick={() => {
            userActions.select(null);
            handleShowModal();
          }}
        >
          {t("add")}
        </button>
      )}
      <SweetAlert
        show={alert.show}
        type={alert.type}
        title={alert.title}
        onConfirm={user.selected._id ? handleRemove : handleCloseAlert}
        onCancel={handleCloseAlert}
        showCancel={user.selected._id}
        cancelBtnCssClass="btn btn-light"
        cancelBtnStyle={{ color: themeColor.black }}
        confirmBtnText={t("ok")}
        cancelBtnText={t("cancel")}
      >
        {alert.content}
      </SweetAlert>
      <Portal
        show={showModal}
        values={user.selected}
        readOnly={!isUpdateAllowed}
      />
      <Table>
        <thead>
          <tr>
            {tableHeader.map((item) => (
              <th scope="col" style={{ whiteSpace: "nowrap" }}>
                {t(item.key)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {staffAccountList.map((staff) => {
            return (
              <tr>
                <td>
                  <ActionDropdown
                    staff={staff}
                    setShowModal={setShowModal}
                    setAlert={setAlert}
                    isUpdateAllowed={isUpdateAllowed}
                  />
                </td>
                <td>{staff.name}</td>
                <td>{staff.username}</td>
                <td style={{ whiteSpace: "nowrap" }}>
                  {t(`profile.staff.${staff.role}`)}
                </td>
                <td>{t(`profile.staff.${staff.status}`)}</td>
              </tr>
            );
          })}
          {staffAccountList.length < 1 ? (
            <tr>
              <td colSpan={tableHeader.length} style={{ textAlign: "center" }}>
                {t("noResults")}
              </td>
            </tr>
          ) : null}
        </tbody>
      </Table>
    </div>
  );
};

export default StaffList;
